<template>
  <div>
    <h3 class="mt-3 mb-4 title primary--text">
      {{ $t('Workload And Shortage') }}
    </h3>
    <v-row class="white">
      <v-col cols="12">
        <div class="d-flex align-center">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            single-line
            hide-details
          />
          <v-btn
            class="ml-4"
            color="secondary"
            @click="exportTable"
          >
            {{ $t('export') }}
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="selectedWorkloadItemsFiltered"
          :search="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :custom-group="customGroup"
          :group-by.sync="groupBy"
          item-key="_id"
        >
          <template v-slot:header.laboratory.name="{header}">
            {{ header.text }}
            <span
              class="mx-3"
              @click="groupBy = header.value"
            >
              {{ $t('Group') }}
            </span>
          </template>

          <template v-slot:header.date="{header}">
            {{ header.text }}
            <span
              class="mx-3"
              @click="groupBy = header.value"
            >
              {{ $t('Group') }}
            </span>
          </template>

          <template v-slot:header.analysis="{header}">
            {{ header.text }}
            <span
              class="mx-3"
              @click="groupBy = header.value"
            >
              {{ $t('Group') }}
            </span>
          </template>

          <template v-slot:body.prepend="data">
            <tr>
              <template v-for="header in data.headers">
                <td :key="header.value">
                  <template v-if="header.value === 'analysis'">
                    <v-autocomplete
                      v-model="filterCategory"
                      class="my-2"
                      :items="workloadAnalysis"
                      dense
                      hide-details
                      outlined
                      color="blue-grey lighten-2"
                      :label="$t('Filter By category')"
                      cache-items
                      clearable
                      return-object
                      item-text="name"
                      @click:clear="[filterGroup = '', filterAnalysisType = '']"
                    />

                    <v-autocomplete
                      v-if="filterCategory"
                      v-model="filterGroup"
                      class="my-2"
                      :items="workloadCategoryGroups"
                      dense
                      hide-details
                      outlined
                      color="blue-grey lighten-2"
                      :label="$t('Filter By sub category')"
                      cache-items
                      return-object
                      clearable
                      @click:clear="filterAnalysisType = ''"
                    />

                    <v-autocomplete
                      v-if="filterGroup"
                      v-model="filterAnalysisType"
                      class="my-2"
                      :items="workloadAnalysisType"
                      dense
                      hide-details
                      outlined
                      color="blue-grey lighten-2"
                      :label="$t('Filter By analysis')"
                      cache-items
                      clearable
                    />
                  </template>

                  <v-text-field
                    v-else-if="header.value === 'numberPerformed'"
                    v-model="numberPerformedInput"
                    type="number"
                    :label="$t('More than')"
                  />

                  <v-text-field
                    v-else-if="header.value === 'numberNotPerformed'"
                    v-model="numberNotPerformedInput"
                    type="number"
                    :label="$t('More than')"
                  />
                </td>
              </template>
            </tr>
          </template>


          <template v-slot:group.header="{group, groupBy, headers, isOpen, toggle, remove, items}">
            <td
              :colspan="headers.length"
              class="text-start"
            >
              <div class="d-flex">
                <div>
                  <v-btn
                    icon
                    small
                    @click="toggle"
                  >
                    <v-icon v-if="isOpen">
                      mdi-minus
                    </v-icon>
                    <v-icon v-else>
                      mdi-plus
                    </v-icon>
                  </v-btn>

                  {{ groupByNameMapper[groupBy] }}: {{ group }}
                  <v-btn
                    icon
                    small
                    @click="remove"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div
                  v-if="groupBy == 'laboratory.name'"
                  class="ml-auto"
                >
                  <v-btn
                    icon
                    :to="{name: 'LaboratoryWorkload', params: {laboratoryId: items[0].laboratory.id}}"
                    target="_blank"
                  >
                    <v-icon
                      small
                    >
                      mdi-open-in-new
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </template>

          <template
            v-slot:item.analysis="{ item }"
          >
            <div>
              <template v-if="item.analysis.name">
                {{ item.analysis.category }} <span class="mx-1">»</span>
                {{ item.analysis.group }} <span class="mx-1">»</span>
                {{ item.analysis.name }}
              </template>
            </div>
          </template>

          <template v-slot:item.comment="{ item }">
            <pre>{{ item.comment }}</pre>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              :to="{name: 'LaboratoryWorkload', params: {laboratoryId: item.laboratory.id}}"
              target="_blank"
            >
              <v-icon
                small
              >
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <line-chart :chart-data="chartDataNumberPerformed_Date" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {groupItems} from 'vuetify/lib/util/helpers'
import moment from 'moment';
import {
  export_json_to_excel_custom
} from '@/vendor/Export2Excel'
import LineChart from "@/components/common/LineChart";

export default {
  name: "ReqToolWorkload",

  components: {
    LineChart
  },

  props: {
    workloadData: {
      type: Array,
      required: true,
    },
    dateRange: {
      type: Array,
      required: true,
    }
  },

  data: () => {
    return {
      search: '',
      sortBy: 'type',
      sortDesc: false,
      // selectedWorkloadDate: '',
      // selectedWorkloadItems: [],

      groupByNameMapper: {
        'laboratory.name': 'Laboratory Name',
        'analysis': 'Analyses'
      },
      groupBy: [],

      filterCategory: '',
      filterGroup: '',
      filterAnalysisType: '',

      numberPerformedInput: '',
      numberNotPerformedInput: '',
    }
  },

  computed: {
    headers() {
      let headers = [
        {
          text: this.$t('Laboratory'),
          value: 'laboratory.name',
          align: 'start',
          sortable: true,
          groupable: true,
        },
        {
          text: this.$t("Date"),
          value: "date",
          align: "start",
          sortable: true,
          groupable: true,
        },
        {
          text: this.$t("Analysis"),
          value: "analysis",
          align: "start",
          sortable: false,
          groupable: true,
        },
        {
          text: this.$t("Number performed"),
          value: "numberPerformed",
          align: "start",
          sortable: true,
          groupable: false
        },
        {
          text: this.$t("Number of days not performed"),
          value: "numberNotPerformed",
          align: "start",
          sortable: true,
          groupable: false
        },
        {
          text: this.$t("Reason"),
          value: "reason",
          align: "start",
          sortable: true,
          groupable: false,
          width: 400,
        },
        {
          text: this.$t("Comment"),
          value: "comment",
          align: "start",
          sortable: true,
          groupable: false,
          width: 400,
        },
        {
          text: this.$t('Actions'),
          value: 'actions',
          align: 'end',
          sortable: false,
          groupable: false,
        },
      ];

      return headers
    },

    selectedWorkloadDataInfo() {
      let data = this.selectedWorkloadItems.map(workload => {
        if (workload.info) {
          workload.info.forEach(info => {
            info.laboratory = workload.laboratory;
            info.date = workload.date;
          });
          workload.info._id = `${workload.info._id}-${workload.laboratory.id}`;

          return workload.info
        }
        return ''
      }).filter(e => e).flat();

      return data

    },

    selectedWorkloadItems() {
      if (this.dateRange.length === 1) {
        return this.workloadData.filter(workload => {
          return workload.date === this.dateRange[0];
        })
      }

      return this.workloadData.filter(workload => moment(workload.date).isBetween(this.dateRange[0], this.dateRange[1], undefined, '[]'))
    },

    selectedWorkloadItemsFiltered() {
      let workloadItems = this.selectedWorkloadDataInfo;

      if (this.filterCategory) {
        workloadItems = workloadItems.filter(item => item.analysis.category === this.filterCategory.name)
      }

      if (this.filterGroup) {
        workloadItems = workloadItems.filter(item => item.analysis.group === this.filterGroup)
      }

      if (this.filterAnalysisType) {
        workloadItems = workloadItems.filter(item => item.analysis.name === this.filterAnalysisType)
      }

      if (parseInt(this.numberNotPerformedInput)) {
        workloadItems = workloadItems.filter(item => item.numberNotPerformed > parseInt(this.numberNotPerformedInput))
      }

      if (parseInt(this.numberPerformedInput)) {
        workloadItems = workloadItems.filter(item => item.numberPerformed > parseInt(this.numberPerformedInput))
      }

      return workloadItems
    },

    workloadAnalysis() {
      let data = this.selectedWorkloadDataInfo.reduce((r, a) => {
        if (!r[a.analysis.category]) {
          r[a.analysis.category] = {
            name: a.analysis.category,
            group: {}
          }
        }
        if (!r[a.analysis.category].group[a.analysis.group]) {
          r[a.analysis.category].group[a.analysis.group] = {}
        }
        r[a.analysis.category].group[a.analysis.group][a.analysis.name] = {};
        return r
      }, {});

      return Object.values(data).map(e => {
        let groups = Object.keys(e.group);
        groups.forEach(g => {
          e.group[g] = Object.keys(e.group[g])

        });
        e.groups = groups;

        return e
      })
    },

    workloadCategoryGroups() {
      return this.filterCategory ? this.filterCategory.groups : []
    },

    workloadAnalysisType() {
      return this.filterGroup ? this.filterCategory.group[this.filterGroup] : []
    },

    chartDataNumberPerformed_Date() {

      let labels = [];
      let dataNumberPerformed = [];
      let dataNumberNotPerformed = [];

      let dataItems = this.selectedWorkloadItemsFiltered.reduce((r, a) => {
        let key = `${a.analysis.category}-${a.analysis.group}-${a.analysis.name}`;
        r[key] = [...r[key] || [], a];
        return r
      }, {});

      let dataForChart = [];

      for (let item of Object.values(dataItems)) {
        let analysis = item[0].analysis;

        let sum = item.reduce((r, a) => {
          r.numberPerformed += +a.numberPerformed;
          r.numberNotPerformed += +a.numberNotPerformed;
          return r
        }, {numberPerformed: 0, numberNotPerformed: 0});


        dataForChart.push({analysis, ...sum})
      }

      for (let item of dataForChart) {
        labels.push(item.analysis.name);
        dataNumberPerformed.push(item.numberPerformed);
        dataNumberNotPerformed.push(item.numberNotPerformed);
      }

      let datasets = [
        {
          label: this.$t('Number Performed'),
          borderColor: '#5e6f91',
          data: dataNumberPerformed,
        },
        {
          label: this.$t('Number of days not performed'),
          borderColor: '#915544',
          data: dataNumberNotPerformed,
          hidden: true
        }
      ];

      return {
        labels,
        datasets
      }
    },
  },

  // watch: {
  //     availableDates() {
  //         this.selectedWorkloadDate = this.availableDates[0];
  //     }
  // },

  methods: {
    customGroup(items, groupBy, groupDesc) {
      if (groupBy[0] === 'analysis') {

        const groupsObject = {};
        let groups = [];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const val = `${item.analysis.category} » ${item.analysis.group} » ${item.analysis.name}`;

          if (!groupsObject[val]) {
            groupsObject[val] = {
              name: val,
              items: [],
            };
          }

          groupsObject[val].items.push(item);

        }

        groups = Object.values(groupsObject);

        return groups;
      }

      return groupItems(items, groupBy, groupDesc)

    },

    exportTable() {
      let multiData = [];

      {
        const tHeader = [
          '#', 'Laboratory', 'Date', 'Analysis', 'Number performed',
          'Number of days not performed', 'Reason', 'Comment'
        ];


        const filterVal = [
          '#', 'laboratory', 'date', 'analysis', 'numberPerformed',
          'numberNotPerformed', 'reason', 'comment'
        ];

        const deepValues = {
          laboratory(item) {
            return item?.laboratory?.name || ''
          },
          analysis(item) {
            return `${item.analysis.category}/${item.analysis.group}/${item.analysis.name}`
          }
        };


        let data = this.selectedWorkloadItemsFiltered.map((v, index) => {
          return filterVal.map(j => {
            if (j === '#') return index + 1;
            if (v[j]) {
              if (j in deepValues) {
                return deepValues[j](v)
              } else {
                return v[j].toString()
              }
            }

            return ''
          });
        }).filter(e => e);

        multiData.push({name: 'Workload and Shortage', header: tHeader, data})
      }

      export_json_to_excel_custom({
        multiData,
        filename: 'workload-shortage',
        autoWidth: true,
      })

    }


  },

}
</script>

<style scoped>

</style>
